/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getPolicyPageContent } from '../../redux/slices/policyPageSlice';

import styles from './policy.module.scss';

function PrivacyPolicy() {
  const dispatch = useDispatch();
  const { policyContent } = useSelector((state) => ({
    policyContent: state.policyPage.policyContent,
  }));

  useEffect(() => {
    dispatch(getPolicyPageContent());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <div>
        {policyContent[2]?.htmlContent && (
          <div
            dangerouslySetInnerHTML={{
              __html: policyContent[2]?.htmlContent,
            }}
          />
        )}
      </div>
    </div>
  );
}

export default PrivacyPolicy;
